import { request } from '@blade/common';
/**
*@Description: 分页查询设备列表
*/
export const getTableList = (data) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/relation/query',
    method: 'POST',
    data,
});
/**
* 删除
*/
export const delListItem = (data) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/relation/delete',
    method: 'POST',
    data,
});
/**
* 添加
*/
export const addListItem = (data) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/relation/add',
    method: 'POST',
    data,
});
// 新增的待选项
export const getLibraryOption = (data) => request({
    // url: '/api/portrait-management/api/v1/automobilelib/library/all/' + libType,
    url: '/api/portrait-management/api/v1/automobilelib/library/all',
    method: 'POST',
    data
});
/**
* 错误列表
*/
export const errList = (data) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/library/distribute/fail',
    method: 'POST',
    data,
});
/**
* 重新发送
*/
export const againIssued = (data) => request({
    url: '/api/iot-device-management/api/v1/dahua/iot/library/distribute/fail/restart',
    method: 'POST',
    data,
});
